module.exports = __webpack_public_path__ + "img/AboutUs.e20024d1.svg";